import React, { useMemo, useState } from 'react';
import {
  calculateFromMahkemeKarari,
  calculateFromBrutUcret,
  parseTRAmount,
  formatMakbuzTL,
  MAKBUZ_KDV_ORANI,
  MAKBUZ_GV_STOPAJ_ORANI,
  MAKBUZ_KDV_TEVKIFAT_ORANI,
} from '../utils/makbuzHesap';
import './MakbuzHesapla.css';

const pct = (n) => `%${Math.round(n * 100)}`;

const MakbuzHesapla = () => {
  const [mod, setMod] = useState('karar');
  const [tutar, setTutar] = useState('');

  const result = useMemo(() => {
    const amount = parseTRAmount(tutar);
    if (!amount) return null;
    return mod === 'karar'
      ? calculateFromMahkemeKarari(amount)
      : calculateFromBrutUcret(amount);
  }, [mod, tutar]);

  const rowsSigorta = result
    ? [
        ['Mahkeme/İcra Kararı', result.mahkemeKarari],
        ['Ücret', result.brutUcret],
        [`${pct(MAKBUZ_KDV_ORANI)} KDV`, result.kdv],
        ['Brüt Ücret', result.brutKdvDahil],
        [`${pct(MAKBUZ_GV_STOPAJ_ORANI)} Stopaj`, result.gvStopaj],
        ['KDV Tevkifatı', result.kdvTevkifat],
        ['Ödenecek KDV', result.odenecekKdv],
        ['Toplam Vekalet Ücreti', result.netTahsilat],
      ]
    : [];

  const rowsMakbuz = result
    ? [
        ['Brüt Ücret Tutarı', result.brutUcret],
        ['KDV Tutarı', result.kdv],
        ['G.V. Stopaj Tutarı', result.gvStopaj],
        ['Net Ücret Tutarı', result.netUcret],
        ['KDV Tevkifatı Tutarı', result.kdvTevkifat],
        ['Tahsil Edilen KDV Tutarı', result.tahsilEdilenKdv],
        ['Net Tutar', result.netTahsilat],
      ]
    : [];

  return (
    <div className="makbuz-hesapla-page">
      <div className="mh-header">
        <h1>Makbuz Hesapla</h1>
        <p>
          Sigortanın gönderdiği tevkifatlı vekalet ücreti dökümünü kontrol edin.
          Oranlar: KDV {pct(MAKBUZ_KDV_ORANI)}, G.V. stopaj {pct(MAKBUZ_GV_STOPAJ_ORANI)},
          KDV tevkifat {pct(MAKBUZ_KDV_TEVKIFAT_ORANI)}.
        </p>
      </div>

      <div className="mh-input-card">
        <div className="mh-tabs">
          <button
            type="button"
            className={`mh-tab ${mod === 'karar' ? 'active' : ''}`}
            onClick={() => setMod('karar')}
          >
            Mahkeme / İcra Kararı
          </button>
          <button
            type="button"
            className={`mh-tab ${mod === 'brut' ? 'active' : ''}`}
            onClick={() => setMod('brut')}
          >
            Brüt Ücret (KDV hariç)
          </button>
        </div>
        <label htmlFor="mh-tutar">
          {mod === 'karar' ? 'Mahkeme / İcra Kararı tutarı' : 'Brüt ücret (makbuzdaki)'}
        </label>
        <input
          id="mh-tutar"
          type="text"
          inputMode="decimal"
          className="mh-input"
          placeholder={mod === 'karar' ? 'Örn: 46.200,21' : 'Örn: 38.500,18'}
          value={tutar}
          onChange={(e) => setTutar(e.target.value)}
        />
      </div>

      {result && (
        <div className="mh-results">
          <div className="mh-table-card">
            <h2>SMM Hesaplama</h2>
            <p className="mh-table-hint">Sigorta ödeme detayı ile karşılaştırın</p>
            <table>
              <tbody>
                {rowsSigorta.map(([label, value], i) => (
                  <tr key={label} className={i === rowsSigorta.length - 1 ? 'mh-total' : ''}>
                    <th>{label}</th>
                    <td>{formatMakbuzTL(value)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mh-table-card">
            <h2>Kesilecek Makbuz</h2>
            <p className="mh-table-hint">Tevkifatlı serbest meslek makbuzu kalemleri</p>
            <table>
              <tbody>
                {rowsMakbuz.map(([label, value], i) => (
                  <tr key={label} className={i === rowsMakbuz.length - 1 ? 'mh-total' : ''}>
                    <th>{label}</th>
                    <td>{formatMakbuzTL(value)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default MakbuzHesapla;
